import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'

/*
 * Where the open record stands in its work queue (useWorkQueue): "3 of 7"
 * over a bar, at the top of the card. Nothing while the queue is loading, or
 * when the record is the only one.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-bottom: 1rem;
`

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.font.label};
  font-size: var(--font-XS);
`

const Track = styled.div`
  height: 0.375rem;
  border-radius: 999px;
  background: ${({ theme }) => theme.form.border};
  overflow: hidden;
`

const Fill = styled.div`
  width: ${({ $share }) => `${Math.round($share * 100)}%`};
  height: 100%;
  border-radius: 999px;
  background: ${({ theme }) => theme.btn.primary};
  transition: width .3s ease-in-out;
`

const WorkQueueProgress = ({ queue, step }) => {
  const { m } = useTranslation()
  if (!step || step.total < 2) return null

  // Done so far, of the whole run: the open record is not done yet.
  const share = (step.position - 1) / step.total
  return (
    <Wrapper data-testid="workQueue.progress" role="progressbar"
      aria-valuemin={0} aria-valuemax={step.total} aria-valuenow={step.position - 1}>
      <Label><span>{m(queue.label, [step.position, step.total])}</span></Label>
      <Track><Fill $share={share} /></Track>
    </Wrapper>
  )
}

export default WorkQueueProgress
